// Barrel file
import KYC from './KYC.json'
import ModusProxyFactory from './ModusProxyFactory.json'
import ModusRegistry from './ModusRegistry.json'
import ModusStaking from './ModusStaking.json'
import ModusToken from './ModusToken.json'
import PriceModule from './PriceModule.json'
import PXRT from './PXRT.json'
import PXT from './PXT.json'
import PXTStaking from './PXTStaking.json'
import StableCoinPXTSwap from './StableCoinPXTSwap.json'
import TokenModusSwap from './TokenModusSwap.json'
import TokenStableCoinSwap from './TokenStableCoinSwap.json'

export {
  KYC,
  ModusProxyFactory,
  ModusRegistry,
  ModusStaking,
  ModusToken,
  PriceModule,
  PXRT,
  PXT,
  PXTStaking,
  StableCoinPXTSwap,
  TokenModusSwap,
  TokenStableCoinSwap
}
